<template>
  <MetricTile
    v-if="density === 'default'"
    :loading="loading"
    :no-data="!metric || !metric.completed"
    icon="fa-solid fa-user-plus"
    :show-duration="false"
    :progress-bar-value="metric?.percentage"
    color="indigo"
  >
    <template #title>Worker Types Complete</template>
    <template #metric-title>Users</template>
    <template #metric>
      {{ metric.completed }}
    </template>
    <template #overMetric>{{ metric.total }}</template>
    <template #additionalMetric> {{ metric.percentage }}%</template>
  </MetricTile>
  <MiniMetricTile v-else-if="density === 'compact'" color="indigo" :loading="loading">
    <template #icon>
      fa-solid fa-user-plus
    </template>
    <template #metric>
      {{ metric?.completed || 0 }}
    </template>
    <template #title>
      Worker Types Complete
    </template>
  </MiniMetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
import {PropType} from "vue";
import MiniMetricTile from "@/components/Metrics/MiniMetricTile.vue";

const {metric, loading} = useMetricTile<
  {
    completed: number;
    percentage: number;
    total: number;
  }>("users-completed-holland-code-ratio");

defineProps({
  density: {
    type: String as PropType<"default" | "compact" | "comfortable">,
    default: "default"
  },
});

</script>
